module.exports = __webpack_public_path__ + "253e0d8f4e0c6348e8368b6e776d2f42.pdf";